import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Card,
  Drawer,
  Grid,
  Group,
  LoadingOverlay,
  Modal,
  ScrollArea,
  Stack,
  useMantineTheme,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { CREATE_AGENT, DEL_AGENT } from "apollo/mutuations";
import { GET_RETAILER_AGENTS } from "apollo/queries";
import RetailerAddModal from "components/Retailer/RetailerAddModal";
import B2bTable from "components/reusable/b2bTable";
import { customLoader } from "components/utilities/loader";
import { useEffect, useState } from "react";
import { Trash } from "tabler-icons-react";

import RetailerDetailModal from "components/Retailer/RetailerDetail";
import RetailerEditModal from "components/Retailer/RetailerEditModal";

import { useForm } from "@mantine/form";
import ActionButton from "components/controls/ActionButtonNew";
import ShowWarehouseLocation from "components/Warehouse/showWarehouseLocation";
import RetailerFilter from "./searchRetailer";

const RetailerAgents = () => {
  const form = useForm({
    initialValues: {
      retailer_id: null,
    },
  });
  const [openedAssign, setOpenedAssigned] = useState(false);
  const [opened, setOpened] = useState(false);
  const [openedDelete, setOpenedDelete] = useState(false);
  const [openedEdit, setOpenedEdit] = useState(false);
  const [editId, setEditId] = useState();
  const [deleteID, setDeleteID] = useState(false);
  const [openedDetail, setOpenedDetail] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [openedLocation, setOpenedLocation] = useState(false);
  const [location, setLocation] = useState({});
  const [activePage, setActivePage] = useState(1);
  const [total, setTotal] = useState(0);
  const [size, setSize] = useState("10");

  const [addAgent, { loading: assignLoading }] = useMutation(CREATE_AGENT, {
    refetchQueries: [
      {
        query: GET_RETAILER_AGENTS,
        variables: {
          first: parseInt(size),
          page: activePage,
          search: searchValue,
          ordered_by: [
            {
              column: "CREATED_AT",
              order: "DESC",
            },
          ],
        },
      },
    ],
    onCompleted(data) {
      setOpenedAssigned(false);
      showNotification({
        color: "green",
        title: "Success",
        message: "Driver assigned successfully!",
      });
    },
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message: `${error.message}`,
      });
    },
  });
  const submit = () => {
    console.log("Submitting form with values:", form.values.retailer_id);
    addAgent({
      variables: {
        retailer_id: parseInt(form.values.retailer_id),
      },
    });
  };
  const { data, loading, refetch } = useQuery(GET_RETAILER_AGENTS, {
    variables: {
      first: parseInt(size),
      page: activePage,
      search: searchValue,
      ordered_by: [
        {
          column: "CREATED_AT",
          order: "DESC",
        },
      ],
    },
    onError(error) {
      setOpenedDelete(false);
      setDeleteID(null);
      showNotification({
        color: "red",
        title: "Error",
        message:
          error?.graphQLErrors?.[0]?.message || "Failed to get retailers ",
      });
    },
  });

  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
  };
  useEffect(() => {
    if (data) {
      setTotal(data.agentSuppliers.paginatorInfo.lastPage);
    }
  }, [data, size]);

  const [delRetailer] = useMutation(DEL_AGENT, {
    update(cache, { data: { deleteAgentSupplier } }) {
      cache.updateQuery(
        {
          query: GET_RETAILER_AGENTS,
          variables: {
            first: parseInt(size),
            page: activePage,
            search: searchValue,
            ordered_by: [
              {
                column: "CREATED_AT",
                order: "DESC",
              },
            ],
          },
        },
        (data) => {
          if (data.agentSuppliers.data.length === 1) {
            setTotal(total - 1);
            setActivePage(activePage - 1);
          } else {
            return {
              agentSuppliers: {
                data: [
                  ...data.agentSuppliers.data.filter(
                    (retailer) => retailer.id !== deleteAgentSupplier.id,
                  ),
                ],
              },
            };
          }
        },
      );
    },
  });

  const handleDelete = (id) => {
    setOpenedDelete(true);
    setDeleteID(id);
  };

  const deleteRetailer = () => {
    delRetailer({
      variables: { id: deleteID },

      onCompleted(data) {
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "green",
          title: "Success",
          message: "Retailer Deleted Successfully",
        });
      },
      onError(error) {
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to delete retailer",
        });
      },
    });
  };

  const handleEditRetailer = (id) => {
    setOpenedEdit(true);
    setEditId(id);
  };
  useEffect(() => {
    refetch();
  }, []);
  const handleChange = (currentPage) => {
    setActivePage(currentPage);
  };
  const theme = useMantineTheme();
  const handleManageRetailer = (id) => {
    setEditId(id);
    setOpenedDetail(true);
  };
  const handleGeoLocationClick = (lat, lng) => {
    setLocation({
      lat: lat,
      lng: lng,
    });
    setOpenedLocation(true);
  };
  const headerData = [
    {
      label: "Name",
      key: "name",
      width: "20%",
      sortable: true,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.retailer.name}</span>;
      },
    },
    {
      label: "Phone",
      key: "contact_phone",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.retailer.contact_phone}</span>;
      },
    },
    {
      label: "Region",
      key: "city",
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.retailer.region?.name}</span>;
      },
    },
    {
      label: "City",
      key: "city",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.retailer.city}</span>;
      },
    },
    {
      label: "Actions",
      key: "actions",
      sortable: false,
      searchable: false,
      width: "15%",
      render: (rowData) => {
        const hasGeo = rowData?._geo && rowData?._geo.lat && rowData?._geo.lng;
        const lat = rowData?._geo?.lat;
        const lng = rowData?._geo?.lng;
        return (
          <div style={{ display: "flex", gap: "6px" }}>
            <ActionButton
              label="Delete"
              color="error"
              onClick={() => handleDelete(`${rowData.id}`)}
            >
              <Trash size={15} />
            </ActionButton>
            {hasGeo && (
              <ActionButton
                label="Location"
                color="primary"
                onClick={() => handleGeoLocationClick(lat, lng)}
              >
                <LocationOnIcon size={15} />
              </ActionButton>
            )}
          </div>
        );
      },
    },
  ];

  const optionsData = {
    actionLabel: "Add Retailer",
    setAddModal: setOpenedAssigned,
  };
  const [confirmedSearch, setConfirmedSearch] = useState("");

  const handleManualSearch = (searchTerm) => {
    setSearchValue(searchTerm);
  };
  const clearInput = () => {
    setSearchValue("");
    setConfirmedSearch("");
  };

  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <div style={{ width: "98%", margin: "auto" }}>
      <Drawer
        opened={openedEdit}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        title="Editing a Retailer"
        padding="xl"
        onClose={() => setOpenedEdit(false)}
        position="bottom"
        size="80%"
      >
        <RetailerEditModal setOpenedEdit={setOpenedEdit} editId={editId} />
      </Drawer>

      <Drawer
        opened={openedDetail}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        title="Retailer Detail"
        padding="xl"
        onClose={() => setOpenedDetail(false)}
        position="bottom"
        size="80%"
      >
        <RetailerDetailModal
          total={total}
          setTotal={setTotal}
          activePage={activePage}
          setActivePage={setActivePage}
          setOpenedDetail={setOpenedDetail}
          Id={editId}
        />
      </Drawer>

      <Modal
        opened={openedDelete}
        onClose={() => setOpenedDelete(false)}
        title="Warning"
        centered
      >
        <p>Are you sure do you want to delete this retailer?</p>
        <Group position="right">
          <Button onClick={() => deleteRetailer()} color="red">
            Delete
          </Button>
        </Group>
      </Modal>
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        title="Adding a Retailer"
        padding="xl"
        size="80%"
        position="bottom"
      >
        <RetailerAddModal
          total={total}
          setTotal={setTotal}
          activePage={activePage}
          setActivePage={setActivePage}
          setOpened={setOpened}
          size={size}
        />
      </Drawer>

      <Card shadow="sm" p="lg">
        <ScrollArea>
          <B2bTable
            total={total}
            paginatorInfo={data?.agentSuppliers?.paginatorInfo}
            activePage={activePage}
            handleChange={handleChange}
            clearInput={clearInput}
            handelSearch={handleManualSearch}
            searchValue={confirmedSearch}
            onSearchChange={setConfirmedSearch}
            header={headerData}
            optionsData={optionsData}
            loading={loading}
            data={data ? data.agentSuppliers.data : []}
            size={size}
            handlePageSizeChange={handlePageSizeChange}
          />
        </ScrollArea>
      </Card>
      <Drawer
        opened={openedAssign}
        onClose={() => setOpenedAssigned(false)}
        styles={{
          closeButton: {
            color: "black",
            marginTop: "10px",
          },
        }}
        padding="xl"
        position="right"
        size="40%"
      >
        <form onSubmit={form.onSubmit(() => submit())}>
          <Stack>
            <Grid>
              <Grid.Col span={6}>
                <RetailerFilter
                  retailer={form.values.retailer_id}
                  onCardClick={(value) =>
                    form.setFieldValue("retailer_id", value)
                  }
                  valueType="id"
                  required={true}
                />
              </Grid.Col>
              <Grid.Col span={3}>
                <Button
                  style={{
                    marginTop: "23px",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  type="submit"
                  fullWidth
                  disabled={assignLoading}
                  loading={assignLoading}
                >
                  Submit
                </Button>
              </Grid.Col>
            </Grid>
          </Stack>
        </form>
      </Drawer>
      <Drawer
        opened={openedLocation}
        onClose={() => setOpenedLocation(false)}
        title="Warehouse Location"
        padding="xl"
        size="80%"
        position="bottom"
      >
        <ShowWarehouseLocation location={location} />
      </Drawer>
    </div>
  );
};

export default RetailerAgents;
